import { reverseDate } from "../../../Helpers/ValidatorHelper"
import { FaRegEdit } from 'react-icons/fa'
import { useAuth } from "../../../Providers/AuthProvider"
import { toast } from "react-toastify"
import AddEditCrmTaskModal from "../../../Components/Components/Modals/AddEditCrmTaskModal"
import { useState } from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"
import ExpandTableText from "../../../Helpers/ExpandTableText"

const CrmEvents = ({ crmEvents, setCrmEvents, lastBookElementRef, isLoading }) => {
    const { authState } = useAuth()
    const [edtCrmObj, setEdtCrmObj] = useState({ show: false, crm: null })

    const handleEditCrmEventClick = (crm) => {
        if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 3) {
            toast.warning('Brak uprawnień')
            return
        }
        setEdtCrmObj({ show: true, crm: crm })
    }

    const popover = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>Edytuj zdarzenie</span>
        </Popover.Body>
    </Popover>

    if (!isLoading && (!crmEvents || crmEvents.length == 0)) {
        return <tr>
            <td colSpan="7" className="text-center py-4">
                <span className="text-muted">Brak danych</span>
            </td>
        </tr>
    }
    else {
        return (
            <>
                <AddEditCrmTaskModal
                    show={edtCrmObj.show}
                    onHide={() => setEdtCrmObj({ show: false, crm: null })}
                    crmEvent={edtCrmObj.crm}
                    setCrmEvents={setCrmEvents}
                />
                {crmEvents.map((event, index) => {
                    if (crmEvents.length === index + 1) {// Jeśli to ostatni element na aktualnej liście, przypisz mu Ref
                        return (
                            <tr key={event.id || index} ref={lastBookElementRef}>
                                <td>
                                    <span>{index + 1}</span>
                                </td>
                                <td>
                                    <span>{event.type}</span>
                                </td>
                                <td>
                                    <span>{event.theme}</span>
                                </td>
                                <td>
                                    <span>{reverseDate(event.eventDateTime.substring(0, event.eventDateTime.indexOf("T")))}</span>
                                </td>
                                <td>
                                    <span>{event.evaluation}</span>
                                </td>
                                <td>
                                    <span>{event.comments}</span>
                                </td>
                                {event.crmType == 'A' || event.flaga == 1 ?
                                    (null)
                                    :
                                    (<td className="element-pointer">
                                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                                            <div>
                                                <FaRegEdit onClick={() => handleEditCrmEventClick(event)} />
                                            </div>
                                        </OverlayTrigger>
                                    </td>)}
                            </tr>
                        )
                    } else {
                        return (
                            <tr key={event.id || index}>
                                <td>
                                    <span>{index + 1}</span>
                                </td>
                                <td>
                                    <span>{event.type}</span>
                                </td>
                                <td>
                                    <span>{event.theme}</span>
                                </td>
                                <td>
                                    <span>{reverseDate(event.eventDateTime.substring(0, event.eventDateTime.indexOf("T")))}</span>
                                </td>
                                <td>
                                    <span>{event.evaluation}</span>
                                </td>
                                <td>
                                    <ExpandTableText
                                        text={event.comments}
                                        maxLength={100}
                                        withModal={true}
                                    />
                                </td>
                                {event.crmType == 'A' || event.flaga == '1' ?
                                    (null)
                                    :
                                    (<td className="element-pointer">
                                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                                            <div>
                                                <FaRegEdit onClick={() => handleEditCrmEventClick(event)} />
                                            </div>
                                        </OverlayTrigger>
                                    </td>)}
                            </tr>
                        )
                    }
                })}
            </>
        )
    }
}

export default CrmEvents